import {default as st} from 'striptags';

import Handlebars from 'handlebars';

if (typeof window === undefined) {
  Handlebars.registerHelper('eq', function (arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('neq', function (arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });
}

export const stripTags = st;

//	JSON destined for an inline <script>: content fields can carry literal
//	"</script>" / "<script>" markup, which terminates the tag early (and is a
//	stored-XSS vector). < is valid in both JS and JSON-LD.
export function jsonForScript(value) {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}

export function replaceContext(text, context) {

  if (!text || typeof text !== 'string' || text.indexOf('{{') === -1) {
    return text;
  }

  try {

    const renderLayer = /\{render\}(.*?)\{\/render\}/igms.exec(text);
    if (renderLayer) {
      text = text.replace(renderLayer[0], renderLayer[1]);
    }

    const template = Handlebars.compile(text);
    const output = template({context, renderer: true});

    return output;

  } catch (e) {
    console.error(e);
  }

  return text;
}

//	Legacy build-replace placeholders resolve from the environment now:
//	PUBLIC_* baked by Vite on the client, process.env on the server. The old
//	Rollup/Sapper builds string-replaced these tokens at build time.
const PLACEHOLDER_ENV = {
  '__CDN__': 'PUBLIC_CDN',
  '__API_PUBLIC__': 'PUBLIC_API',
  '__API__': 'PUBLIC_API',
  '__CONTENT_SERVER__': 'PUBLIC_CONTENT_SERVER',
  '__PUSH_VAPID_KEY__': 'PUBLIC_PUSH_VAPID_KEY',
};

//	Static property accesses only: Vite replaces `import.meta.env.PUBLIC_X`
//	literally at build/dev transform time — a dynamic `import.meta.env[name]`
//	lookup is NOT replaced and silently yields undefined in the browser.
function viteEnv(envName) {
  try {
    switch (envName) {
      case 'PUBLIC_CDN': return import.meta.env.PUBLIC_CDN;
      case 'PUBLIC_API': return import.meta.env.PUBLIC_API;
      case 'PUBLIC_CONTENT_SERVER': return import.meta.env.PUBLIC_CONTENT_SERVER;
      case 'PUBLIC_PUSH_VAPID_KEY': return import.meta.env.PUBLIC_PUSH_VAPID_KEY;
    }
  } catch (e) {
    // not a vite context
  }
  return undefined;
}

function resolvePlaceholder(envName, key) {
  //	empty string counts as unset (Docker build args default to '') so the
  //	server-side fallback to runtime process.env below still applies
  const v = viteEnv(envName);
  if (v !== undefined && v !== '') {
    return v;
  }

  if (typeof process !== 'undefined' && process.env) {
    const unprefixed = envName.replace('PUBLIC_', '');
    if (process.env[envName] !== undefined) return process.env[envName];
    if (process.env[unprefixed] !== undefined) return process.env[unprefixed];
  }

  return key;
}

export function getServerValue(key) {

  if (PLACEHOLDER_ENV[key]) {
    return resolvePlaceholder(PLACEHOLDER_ENV[key], key);
  }

  try {

    const data = JSON.parse(decodeURIComponent(key));

    try {

      if (typeof process != undefined) {
        const x = process.env[data.key.split('.').pop()];
        if (x) {
          return x;
        }
      }

      return data.value;

    } catch (e) {
      return data && data.value ? data.value : key;
    }
  } catch (e) {
    return key;
  }
}

